import actionTypes from './actionTypes';

export const toggleCard = function(value = {}) {
    return {
        type: actionTypes.CHANGE_CARD,
        value,
    };
};
export const lang = function(value = 'uk') {
    return {
        type: actionTypes.LANG,
        value,
    };
};
export const pageTitle = function(value) {
    return {
        type: actionTypes.PAGE_TITLE,
        value,
    };
};

export const showLogout = function(value = true) {
    return {
        type: actionTypes.TOGGLE_LOGOUT,
        value,
    };
};

export const hideLogout = function(value = false) {
    return {
        type: actionTypes.TOGGLE_LOGOUT,
        value,
    };
};

export default {
    lang,
    pageTitle,
    showLogout,
    hideLogout,
};
